import { Injectable } from '@angular/core';
import { EventMessage } from '@azure/msal-browser';
import { BehaviorSubject } from 'rxjs';

import { mockInProgress } from './msal-mock.factory';

@Injectable({ providedIn: 'root' })
export class MsalBroadcastMockService {
  inProgress$ = mockInProgress.asObservable();
  private msalSubject = new BehaviorSubject<EventMessage | null>(null);
  msalSubject$ = this.msalSubject.asObservable();

  /**
   * Helper for tests/local dev to simulate MSAL events
   */
  emitEvent(event: EventMessage) {
    this.msalSubject.next(event);
  }
}
